import { StudentResourceEnrolmentStatus } from '@duke-hq/svc-api-db/client';
import { StudentScheduleItemType } from '@duke-hq/svc-api-db/schemas/enums/StudentScheduleItemType.schema';

export enum UnitItemState {
  FUTURE = 'FUTURE',
  THIS_WEEK = 'THIS_WEEK',
  DUE = 'DUE',
  OVERDUE = 'OVERDUE',
  COMPLETED = 'COMPLETED',
  SUBMITTED = 'SUBMITTED',
}
export enum ScheduleWeekState {
  FUTURE = 'FUTURE',
  THIS_WEEK = 'THIS_WEEK',
  OVERDUE = 'OVERDUE',
  AT_RISK = 'AT_RISK',
}

export type CourseEnrolmentScheduleItemType = {
  id: string;
  semester: number;
  // RE: adminCourseScheduleWeek
  // Week number in the course schedule could go from 1 - 26 weeks and is different from the semester
  // weeks which start at 1 for each separate semester and so could be 1 - 13 weeks
  adminCourseScheduleWeek?: number;
  position: number;
  title: string;
  isComplete: boolean;
  startedAt?: Date;
  unitOfCompetencyId: string;
  unitOfCompetencyCode: string;
  assessmentEnrolmentId?: string;
  assessmentEnrolmentStatus?: StudentResourceEnrolmentStatus;
  resourceLastPublishedVersionId?: number;
  resourceEnrolmentId?: string;
  resourceEnrolmentStatus?: StudentResourceEnrolmentStatus;
  itemId: string;
  itemType: StudentScheduleItemType;
  progress: number;
  courseEnrolmentId: number;
  disabled: boolean;
  isCourseItemAbleToBeStarted: boolean;
  startDate: Date;
  dueDate: Date;
  firstSubmittedAt: Date | null;
  unitAssessmentLastPublishedVersionId?: string;
  estimatedCompletionMinutes: number | null;
};
